module.exports = __webpack_public_path__ + "img/weektodo-isologo-color.96987a3f.svg";